var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.25C6.41421 2.25 6.75 2.58579 6.75 3V4H16.25V3C16.25 2.58579 16.5858 2.25 17 2.25C17.4142 2.25 17.75 2.58579 17.75 3V4H20C21.1046 4 22 4.89543 22 6V7.25H2V6C2 4.89543 2.89543 4 4 4H5.25V3C5.25 2.58579 5.58579 2.25 6 2.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.75H2V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V8.75ZM10.56 18C10.3867 18 10.25 17.9533 10.15 17.86C10.0567 17.76 10.01 17.6267 10.01 17.46C10.01 17.2867 10.0567 17.1567 10.15 17.07C10.25 16.9833 10.3867 16.94 10.56 16.94H11.68V12.4054L10.83 12.92C10.7033 12.9933 10.5833 13.0233 10.47 13.01C10.3633 12.99 10.27 12.9433 10.19 12.87C10.1167 12.79 10.0667 12.6967 10.04 12.59C10.0133 12.4833 10.02 12.3767 10.06 12.27C10.1067 12.1567 10.1933 12.0633 10.32 11.99L11.7 11.16C11.8333 11.08 11.9667 11.0133 12.1 10.96C12.2333 10.9 12.3567 10.87 12.47 10.87C12.61 10.87 12.7267 10.91 12.82 10.99C12.9133 11.0633 12.96 11.1867 12.96 11.36V16.94H13.98C14.1533 16.94 14.2867 16.9833 14.38 17.07C14.48 17.1567 14.53 17.2867 14.53 17.46C14.53 17.6333 14.48 17.7667 14.38 17.86C14.2867 17.9533 14.1533 18 13.98 18H10.56Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.4adea9d4f881f655b41946faf8f36042.svg";
export { ForwardRef as ReactComponent };